import { render, staticRenderFns } from "./student_lookup.vue?vue&type=template&id=4d9ddecd&scoped=true&"
import script from "./student_lookup.vue?vue&type=script&lang=ts&"
export * from "./student_lookup.vue?vue&type=script&lang=ts&"
import style0 from "./student_lookup.vue?vue&type=style&index=0&id=4d9ddecd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9ddecd",
  null
  
)

export default component.exports